// @flow

// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import _reverse from 'lodash/reverse'
import _head from 'lodash/head'
import _get from 'lodash/get'
import _keyBy from 'lodash/keyBy'

// Turf
import turfCenter from '@turf/center'
import turfArea from '@turf/area'
import { coordAll } from '@turf/meta'

// Utils
import traverse from 'fc-utils/traverse'
import convert from 'convert-units'
import emptyObjectOr from 'fc-utils/emptyObjectOr'
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Selectors
import { fieldsOfSelectedFarmAndSeason$ } from 'hfty-assets'
import selectedJobAndGrid$ from 'hfty-soil-jobs/src/selectors/selectedJobAndGrid'
import operation$ from 'hfty-soil-jobs-dom/src/selectors/operation'

// Constants
import {
  PROP_ASSET_ID,
  PROP_SHAPE,
} from 'fc-model-assets'

import {
  PROP_SHAPE_DATA,
} from 'fc-model-shapes'

import {
  GRID_UNIT_ACRES,
} from 'hfty-model-grid'

// Local Utils
const getShape = traverse([PROP_SHAPE])
const getShapeData = traverse([PROP_SHAPE, PROP_SHAPE_DATA])

// Export
export const fields$ = createSelector(
  [fieldsOfSelectedFarmAndSeason$, operation$, selectedJobAndGrid$],
  function (fields: Array<Asset>, currentOperation: Object, selectedJobAndGrid: Object): Array<Asset> {
    console.warn('Recompute fields array')
    return emptyArrayOr(_map(
      _filter(fields, getShape),
      (field: Asset): Asset => {
        const shape = getShape(field)
        const shapeData = getShapeData(field)
        const centroid = _reverse(_head(coordAll(turfCenter(shapeData))))
        let units = ''
        if (currentOperation) {
          units = _get(currentOperation, 'model.gridData.grid.units', GRID_UNIT_ACRES)
        } else {
          units = _get(selectedJobAndGrid, 'grid.features[0].properties.units', GRID_UNIT_ACRES)
        }
        const area = convert(turfArea(shapeData)).from('m2').to('ac').toFixed(2)

        return {
          ...field,
          [PROP_SHAPE]: {
            ...shape,
            [PROP_SHAPE_DATA]: {
              ...shapeData,
              centroid,
              area,
              units,
            },
          },
        }
      }
    ))
  }
)

export const fieldsById = createSelector(
  [fields$],
  function (assets: AssetsById): Array<Asset> {
    return emptyObjectOr(_keyBy(fields$, PROP_ASSET_ID))
  }
)

export default fields$
